<template>
    <rkm-layout-body title="Lista de motivos de baixa">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'almoxarifado-motivo-baixa-create' })"
                color="primary"
                authorize="store-almoxarifado-motivo-baixa"
            >
                Cadastrar motivo de baixa
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/almoxarifado/motivo-baixa/List'

export default {
    components: { List },
}
</script>